import ReactPlayer from "react-player";
import React, {useState} from "react";
import MultimediaVideoTaifun from "./MultimediaVideoTaifun";
import MultimediaVideoBirthday from "./MultimediaVideoBirthday";
import MultimediaVideoEmployees from "./MultimediaVideoEmployees";

export interface MultimediaVideoProps {
    onEnded: () => any;
}

enum VideoMode {
    TAIFUN,
    BIRTHDAY,
    EMPLOYEES,
}

interface MultimediaVideoControllerProps {
    onDone: () => void;
    showTeamPhotos?: boolean;
}

export default function MultimediaVideo({onDone, showTeamPhotos = false}: MultimediaVideoControllerProps) {
    const [videoMode, setVideoMode] = useState<VideoMode>(VideoMode.TAIFUN);

    const handleTaifunEnd = () => {
        if (showTeamPhotos) {
            setVideoMode(VideoMode.EMPLOYEES);
        } else {
            onDone();
        }
    };

    const handleEmployeesEnd = () => {
        setVideoMode(VideoMode.BIRTHDAY);
    };

    const handleBirthdayEnd = () => {
        onDone();
    };

    return (
        <>
            {videoMode === VideoMode.TAIFUN && <MultimediaVideoTaifun onEnded={handleTaifunEnd}/>}

            {showTeamPhotos && videoMode === VideoMode.EMPLOYEES &&
                <MultimediaVideoEmployees onEnded={handleEmployeesEnd}/>}

            {showTeamPhotos && videoMode === VideoMode.BIRTHDAY &&
                <MultimediaVideoBirthday onEnded={handleBirthdayEnd}/>}
        </>
    )
}
